import { Link } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { Button } from "@mui/material";

interface ButtonProps {
  to: string;
  title?: string;
  isSmScreen?: boolean;
}

export default function BackToPreviousPageButton({
  to,
  title = "Cofnij",
  isSmScreen,
}: ButtonProps) {
  return (
    <Button
      component={Link}
      to={to}
      variant="outlined"
      size="small"
      startIcon={<ArrowBack />}
      sx={{
        color: "#6366f1",
        borderColor: "#6366f1",
        "&:hover": { backgroundColor: "#f1e7de", borderColor: "#6366f1" },
        py: 0.5,
        px: 1.5,
        fontSize: "0.75rem",
        minWidth: "auto",
        "&:disabled": {
          color: "#9ca3af",
          borderColor: "#9ca3af",
        },
      }}
    >
      {title}
    </Button>
  );
}
